import { useContext, useState } from 'react'

import { EditContext } from 'Components/Hooks/ContextEdit'
import CustomButton from 'Components/UI/Atoms/CustomButton'
import useCustomSnackbar from 'Components/UI/Atoms/SnackBar'
import ContentWithSubTabs from 'Components/UI/Molecules/ContentWithSubTabs'
import InputsWithoutValidate from 'Components/UI/Molecules/InputsWithoutValidate'
import useStyles from 'Components/UI/Organisms/Vehicles/Quotations/Edit/Fields/Home/styles'
import { interfaces } from 'service/interfaces'

import { CLIENT_DATA } from './ClientData'
import { RECEIPT_DATA } from './ReceiptData'

const HomeContent = (props) => {
  const {
    data,
    setData,
    permissions,
    setLoading,
    empresaId,
    handleclose,
    setRender,
    render,
    loading,
  } = props
  const [edit] = useContext(EditContext)

  const [tab, setTab] = useState(0)

  const createDismissableSnackbar = useCustomSnackbar()

  const handleChange = (name, value) => {
    setData((prevData) => ({
      ...prevData,
      receipt: {
        ...prevData.receipt,
        [name]: value,
      },
    }))
  }

  const classes = useStyles()

  async function onSubmit() {
    setLoading(true)
    await interfaces.salesReceipt
      .generateReceipt(data.receipt.id, empresaId)
      .then((res) => {
        createDismissableSnackbar(res.data, {
          variant: 'success',
        })
        handleclose()
        setRender(!render)
      })
      .catch(() => {
        createDismissableSnackbar('Algo salió mal!', {
          variant: 'error',
        })
      })
    handleclose()
    setLoading(false)
  }

  function renderTabs(index) {
    switch (index) {
      case 0:
        return (
          <>
            <InputsWithoutValidate
              fields={RECEIPT_DATA(data.receipt, handleChange, edit, permissions)}
              spacing={2}
            />
            <div className={classes.buttons} style={{ marginTop: '10px' }}>
              <CustomButton
                buttonEnd
                text="Generar recibo"
                onClick={onSubmit}
                disabled={
                  loading || data.receipt.estado === 'Registrado'
                    ? true
                    : data.receiptDetails.length > 0 && Number(data.receipt.total) > 0
                      ? false
                      : true
                }
              />
            </div>
          </>
        )

      case 1:
        return (
          <>
            <InputsWithoutValidate fields={CLIENT_DATA(data.cliente)} spacing={2} />
          </>
        )
      default:
        break
    }
  }

  const verticalTabs = [
    {
      id: 0,
      title: 'Datos recibo',
    },
    {
      id: 1,
      title: 'Datos cliente',
    },
  ]

  return (
    <div>
      <ContentWithSubTabs
        listVerticalTabs={verticalTabs}
        value={tab}
        setValue={setTab}
        children={<div style={{ margin: '20px' }}>{renderTabs(tab)}</div>}
      />
    </div>
  )
}

export default HomeContent
